// context/IndexSymbolContext.jsx

import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
const IndexSymbolContext = createContext({});

export const IndexSymbolProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [indexSymbols, setIndexSymbols] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadSymbols = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/index-symbols`);
        if (response.data?.indexes) {
          setIndexSymbols(response.data.indexes);
        }
      } catch (err) {
        console.error("Failed to load index symbols", err);
      } finally {
        setLoaded(true);
      }
    };

    loadSymbols();
  }, []);

  return (
    <IndexSymbolContext.Provider value={{ indexSymbols, loaded }}>
      {children}
    </IndexSymbolContext.Provider>
  );
};

export const useIndexSymbols = () => useContext(IndexSymbolContext);
